import $ from 'jquery'
$(document).ready(function(){
  if(document.getElementById('slideshowHome') !== null){
    document.getElementById('slideshowHome').getElementsByClassName('item')[0].classList.add('active');
    document.getElementById('slideshowHome').getElementsByClassName('indicators')[0].classList.add('active');
    $('#slideshowHome').carousel()
  }
})




// WEBPACK FOOTER //
// ./resources/assets/js/app.js